"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MOCK_ANALYTICS_CLIENT: function() {
        return MOCK_ANALYTICS_CLIENT;
    },
    NOOP_ANALYTICS_CLIENT: function() {
        return NOOP_ANALYTICS_CLIENT;
    }
});
const MOCK_ANALYTICS_CLIENT = {
    setExperimentTreatment () {
        throw new Error('Attempted to call `setExperimentTreatment()` on the server! This is not allowed and all calls should be done in a useEffect hook or event handler.');
    },
    trackEvent () {
        throw new Error('Attempted to call `trackEvent()` on the server! This is not allowed and all calls should be done in a useEffect hook or event handler.');
    },
    trackPage () {
        throw new Error('Attempted to call `trackPage()` on the server! This is not allowed and all calls should be done in a useEffect hook or event handler.');
    },
    trackVitals () {
        throw new Error('Attempted to call `trackVitals()` on the server! This is not allowed and all calls should be done in a useEffect hook or event handler.');
    },
    get config () {
        return undefined;
    }
};
const NOOP_ANALYTICS_CLIENT = {
    setExperimentTreatment () {
        return Promise.resolve();
    },
    trackEvent () {
        return Promise.resolve();
    },
    trackPage () {
        return Promise.resolve();
    },
    trackVitals () {
        return Promise.resolve();
    },
    get config () {
        return undefined;
    }
};

//# sourceMappingURL=types.js.map